var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCvv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon-CVV",
    transform: "translate(0 -3)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path",
    d: "M2.25 19.5h19.5a.75.75 0 0 0 .75-.75V5.25a.75.75 0 0 0-.75-.75H2.25a.75.75 0 0 0-.75.75v13.5a.75.75 0 0 0 .75.75zm0 1.5A2.25 2.25 0 0 1 0 18.75V5.25A2.25 2.25 0 0 1 2.25 3h19.5A2.25 2.25 0 0 1 24 5.25v13.5A2.25 2.25 0 0 1 21.75 21zM3.694 7.5a.752.752 0 0 1 0-1.5h16.612a.752.752 0 0 1 0 1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Highlight",
    d: "M12.5 14.5v-4h7v4zm6-1v-2h-5v2zM12.75 16A1.7 1.7 0 0 1 11 14.341v-3.682A1.7 1.7 0 0 1 12.75 9h6.5A1.7 1.7 0 0 1 21 10.659v3.682A1.7 1.7 0 0 1 19.25 16zm0-1h6.5a.7.7 0 0 0 .75-.659v-3.682a.7.7 0 0 0-.75-.659h-6.5a.7.7 0 0 0-.75.659v3.682a.7.7 0 0 0 .75.659z",
    style: {
      fill: "#f63"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCvv);
export default __webpack_public_path__ + "static/media/icon-cvv.126bc322.svg";
export { ForwardRef as ReactComponent };